<template>
  <div>
    <NutritionWorkshopComp v-bind:mobile="mobile"/>
    <RedirectActivitiesComp v-bind:mobile="mobile"/>
    <FollowUs v-bind:mobile="mobile"/>
  </div>
</template>

<script>
import RedirectActivitiesComp from '@/components/desktop/Activities/RedirectActivitiesComp'
import NutritionWorkshopComp from '@/components/desktop/Activities/NutritionWorkshopComp'
import FollowUs from '@/components/desktop/FollowUs'

  export default {
    name: 'NutritionWorkshop',
    props: ['mobile'],
    components: {
      NutritionWorkshopComp,
      RedirectActivitiesComp,
      FollowUs
    },
  }
</script>
